export default "<div style=\"min-height: 15px;\" class=\"emailContainer\">\n    <div data-dojo-attach-point=\"displayField\"></div>\n</div>\n"